import gql from 'graphql-tag';

const collegeEventLocationFragment = gql`
  fragment CollegeEventLocation on CollegeEventLocation {
    id
    name
    street
    street2
    city
    state
    postalCode
    country
    visible
    version
    unpublishedEventCount
    publishedEventCount
    expiredEventCount
  }
`;

export default collegeEventLocationFragment;
